import { Component, ElementRef, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { IonicPage, MenuController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { IMqttMessage, MqttService } from 'ngx-mqtt';
import { interval, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { OPCProvider } from '../../providers/opc/opc';
import { WeatherProvider } from '../../providers/weather/weather';
import { DashDetailPage } from '../dash-detail/dash-detail';

@IonicPage()
@Component({
  selector: "page-dash-tello",
  templateUrl: "dash-tello.html",
})
export class DashTelloPage {
  TEL01LoadChart: Chart;
  @ViewChild("TEL01LoadCanvas") TEL01LoadCanvas: ElementRef;

  TEL02LoadChart: Chart;
  @ViewChild("TEL02LoadCanvas") TEL02LoadCanvas: ElementRef;

  MPP_SITE: string = "MPP Tello";
  MPP_LOCATION: string = "Makassar";
  MPP_COUNT_ENGINE: number = 2;
  MPP_ENGINE_TEXT: string = "2 x 25 MW";

  _MAXMW: number = 25000 / 1000;

  ENGINE: any = ["TELTM01", "TELTM02"];
  TAGS: any = [
    "U1_AI0011",
    "U1_AI0025",
    "U1_AI0033",
    "U1_AI0069",
    "U1_AI0073",
    "U1_AI0077",
    "U1_AI0085",
    "U1_AI0087",
    "U1_AI0089",
    "U1_AI0091",
    "U1_AI0093",
    "U1_AI0095",
    "U1_AI0097",
    "U1_AI0099",
    "U1_AI0101",
    "U1_AI0103",
    "U1_AI0105",
    "U1_AI0107",
    "U1_AI0109",
    "U1_AI0111",
    "U1_AI0113",
    "U1_AI0115",
    "U1_AI0213",
    "U1_AI0214",
    "U1_AI0215",
    "U1_AI0216",
    "U1_AI0217",
    "U1_AI0389",
    "U1_AI0401",
    "U1_AI0402",
    "U1_AI0403",
    "U1_AI0404",
    "U1_AQ7651",
    "U1_AQ7653",
    "U1_AQ7657",
    "U1_I00007",
    "U1_I03647",
    "U1_R05355",
    "U1_R05381",
    "U1_R14007",
    "U1_R14009",
    "U1_R14029",
    "U1_R14031",
    "U1_R14049",
    "U1_R14059",
    "U1_R14069",
    "U1_R14079",
    "U1_R15009",
  ];

  TOPICS: any = ["mpp/tello01", "mpp/tello02"];

  MQTTSubscriber = {};
  data = {};
  data_last = {};

  LOADSubscriber = {};
  historyLoadData = {};
  graphData = {};

  viewDetailEngine = {};

  clock: any;
  weather: any;
  _reqWeather: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private menuCtrl: MenuController,
    private weatherPrvdr: WeatherProvider,
    private OPCPrvdr: OPCProvider,
    private mqttSvc: MqttService
  ) {
    this.structuringData();
  }

  ionViewDidLoad() {
    this.menuCtrl.enable(true);
  }

  ionViewWillEnter() {
    this.clock = interval(1000).pipe(map(() => new Date()));
    this._reqWeather = timer(0, 60000)
      .pipe(switchMap(() => this.weatherPrvdr.getLocation(this.MPP_SITE)))
      .subscribe((res: any) => {
        if (res.success === true) {
          this.weather = res.data;
        }
      });

    this.subscribeMQTT();
    this.subscribeLOAD();
  }

  ionViewDidEnter() {
    this.ENGINE.forEach((engine) => {
      this.plotLoadChart(engine);
      this.updateLoadChart(engine);
    });
  }

  ionViewWillLeave() {
    this._reqWeather.unsubscribe();
    Object.keys(this.MQTTSubscriber).forEach((key) => {
      this.MQTTSubscriber[key].unsubscribe();
    });
    Object.keys(this.LOADSubscriber).forEach((key) => {
      this.LOADSubscriber[key].unsubscribe();
    });
  }

  ionViewDidLeave() {
    // this.ENGINE.forEach((engine) => {
    //   this.lineChartLoadHistory[engine].clear();
    // });
  }

  structuringData() {
    this.ENGINE.forEach((engine) => {
      this.data[engine] = {};
      this.data_last[engine] = "...";
      this.graphData[engine] = {
        WAKTU: [],
        MAX: [],
        MW: [],
        MVAR: [],
      };
    });
    this.TOPICS.forEach((topic) => {
      this.TAGS.forEach((tag) => {
        if (topic === "mpp/tello01") {
          if (tag === "U1_I00007" || tag === "U1_I03647") {
            this.data["TELTM01"][tag] = "...";
          } else {
            this.data["TELTM01"][tag] = 0;
          }
        } else if (topic === "mpp/tello02") {
          if (tag === "U1_I00007" || tag === "U1_I03647") {
            this.data["TELTM02"][tag] = "...";
          } else {
            this.data["TELTM02"][tag] = 0;
          }
        }
      });
    });
  }

  subscribeMQTT() {
    this.TOPICS.forEach((topic) => {
      this.MQTTSubscriber[topic] = this.mqttSvc
        .observe(topic)
        .subscribe((message: IMqttMessage) => {
          let payload: any = this.binArrayToJson(message.payload);

          payload.forEach((data) => {
            let x_tag = data.id.split(".")[2];

            if (
              x_tag === "U1_AI0011" ||
              x_tag === "U1_AI0389" ||
              x_tag === "U1_AI0213" ||
              x_tag === "U1_AI0214" ||
              x_tag === "U1_AI0215" ||
              x_tag === "U1_AI0216" ||
              x_tag === "U1_AI0217"
            ) {
              // DIV 10
              if (data.v === 0) {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = data.v.toFixed(2);
                }
              } else {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = (data.v / 10).toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = (data.v / 10).toFixed(2);
                }
              }
            } else if (
              x_tag === "U1_AQ7651" ||
              x_tag === "U1_AQ7653" ||
              x_tag === "U1_AQ7657"
            ) {
              // DIV 1000
              if (data.v === 0) {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = data.v.toFixed(2);
                }
              } else {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = (data.v / 1000).toFixed(2);
                }
              }
            } else if (x_tag === "U1_R05381") {
              // DIV 3600
              if (data.v === 0) {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = data.v.toFixed(2);
                }
              } else {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = (data.v / 3600).toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = (data.v / 3600).toFixed(2);
                }
              }
            } else if (x_tag === "U1_I00007") {
              // STATUS CB GENERATOR
              if (topic === "mpp/tello01") {
                this.data["TELTM01"][x_tag] = data.v;
              } else if (topic === "mpp/tello02") {
                this.data["TELTM02"][x_tag] = data.v;
              }
            } else if (x_tag === "U1_I03647") {
              // STATUS OPERATION FUEL
              if (topic === "mpp/tello01") {
                this.data["TELTM01"][x_tag] = data.v;
              } else if (topic === "mpp/tello02") {
                this.data["TELTM02"][x_tag] = data.v;
              }
            } else {
              if (data.v === 0) {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = parseFloat(data.v).toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = parseFloat(data.v).toFixed(2);
                }
              } else {
                if (topic === "mpp/tello01") {
                  this.data["TELTM01"][x_tag] = parseFloat(data.v).toFixed(2);
                } else if (topic === "mpp/tello02") {
                  this.data["TELTM02"][x_tag] = parseFloat(data.v).toFixed(2);
                }
              }
            }

            if (topic === "mpp/tello01") {
              if (
                this.data_last["TELTM01"] === "..." ||
                this.data_last["TELTM01"] < data.t
              )
                this.data_last["TELTM01"] = data.t;
            } else if (topic === "mpp/tello02") {
              if (
                this.data_last["TELTM02"] === "..." ||
                this.data_last["TELTM02"] < data.t
              )
                this.data_last["TELTM02"] = data.t;
            }
          });
        });
    });
  }

  subscribeLOAD() {
    this.ENGINE.forEach((engine) => {
      this.LOADSubscriber[engine] = timer(0, 60000)
        .pipe(switchMap(() => this.OPCPrvdr.getLoadHistory1524(engine)))
        .subscribe(async (res: any) => {
          if (res.success === true) {
            this.historyLoadData[engine] = res.data;
            this.graphData[engine] = {
              WAKTU: [],
              MAX: [],
              MW: [],
              MVAR: [],
            };

            await this.historyLoadData[engine].forEach((data) => {
              this.graphData[engine].MAX.push(25);
              this.graphData[engine].WAKTU.push(
                moment(data.waktu).format("HH:mm")
              );
              this.graphData[engine].MW.push(data.mw);
              this.graphData[engine].MVAR.push(data.mvar);
            });
            this.updateLoadChart(engine);
          }
        });
    });
  }

  plotLoadChart(engine) {
    let loadChartOptions = {
      type: "line",
      options: {
        maintainAspectRatio: false,
        tooltips: { enabled: true },
        animation: false,
        legend: {
          display: true,
          labels: {
            fontSize: 10,
            fontFamily: "PT Sans Narrow",
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 8,
                fontFamily: "PT Sans Narrow",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontSize: 8,
                fontFamily: "PT Sans Narrow",
              },
            },
          ],
        },
      },
      data: {
        labels: [],
        datasets: [
          {
            label: "MAX",
            data: [],
            fill: true,
            lineTension: 0,
            backgroundColor: "rgba(255,171,87,.2)",
            borderColor: "rgba(255,171,87,1)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            borderWidth: 1,
            pointBorderColor: "rgba(255,171,87,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false,
            pointHoverBackgroundColor: "rgba(255,171,87,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
          },
          {
            label: "MW",
            data: [],
            fill: true,
            lineTension: 0.3,
            backgroundColor: "rgba(54,162,235,.2)",
            borderColor: "rgba(54,162,235,1)",
            borderCapStyle: "round",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "round",
            borderWidth: 2,
            pointBorderColor: "rgba(54,162,235,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 2,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false,
            pointHoverBackgroundColor: "rgba(54,162,235,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
          },
          {
            label: "MVAR",
            data: [],
            fill: true,
            lineTension: 0.3,
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)",
            borderCapStyle: "round",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "round",
            borderWidth: 1,
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointHoverRadius: 6,
          },
        ],
      },
    };

    if (engine === "TELTM01") {
      this.TEL01LoadChart = new Chart(
        this.TEL01LoadCanvas.nativeElement,
        loadChartOptions
      );
    } else if (engine === "TELTM02") {
      this.TEL02LoadChart = new Chart(
        this.TEL02LoadCanvas.nativeElement,
        loadChartOptions
      );
    }
  }

  updateLoadChart(engine) {
    if (engine === "TELTM01") {
      if (this.TEL01LoadChart instanceof Chart) {
        // Removing Data
        this.TEL01LoadChart.data.labels.pop();
        this.TEL01LoadChart.data.datasets.forEach((dataset) => {
          dataset.data.pop();
        });
        this.TEL01LoadChart.update();

        // Updating Data
        this.TEL01LoadChart.data.labels = this.graphData[engine].WAKTU;
        this.TEL01LoadChart.data.datasets[0].data = this.graphData[engine].MAX;
        this.TEL01LoadChart.data.datasets[1].data = this.graphData[engine].MW;
        this.TEL01LoadChart.data.datasets[2].data = this.graphData[engine].MVAR;
        this.TEL01LoadChart.update();
      } else {
        // Create if not exist
        this.plotLoadChart(engine);
      }
    } else if (engine === "TELTM02") {
      if (this.TEL02LoadChart instanceof Chart) {
        // Removing Data
        this.TEL02LoadChart.data.labels.pop();
        this.TEL02LoadChart.data.datasets.forEach((dataset) => {
          dataset.data.pop();
        });
        this.TEL02LoadChart.update();

        // Updating Data
        this.TEL02LoadChart.data.labels = this.graphData[engine].WAKTU;
        this.TEL02LoadChart.data.datasets[0].data = this.graphData[engine].MAX;
        this.TEL02LoadChart.data.datasets[1].data = this.graphData[engine].MW;
        this.TEL02LoadChart.data.datasets[2].data = this.graphData[engine].MVAR;
        this.TEL02LoadChart.update();
      } else {
        // Create if not exist
        this.plotLoadChart(engine);
      }
    }
  }

  toggleDetailEngine(engine) {
    // will be used for management
  }

  showDetail(engine) {
    this.navCtrl.push(DashDetailPage, {
      engine: engine,
      data: this.data[engine],
      data_last: this.data_last[engine],
    });
  }

  JsonToArray(json) {
    let str = JSON.stringify(json, null, 0);
    let ret = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
      ret[i] = str.charCodeAt(i);
    }
    return ret;
  }

  binArrayToJson(binArray) {
    let str = "";
    for (let i = 0; i < binArray.length; i++) {
      str += String.fromCharCode(parseInt(binArray[i]));
    }
    return JSON.parse(str);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dash-tello/dash-tello.ts